import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import SensorTypeTableService from '../service/SensorTypeTableService';

const config = {
	key: 'sensorTypeTable',
	text: 'Sensor Type',
	textKey: 'sensorType',
	service: SensorTypeTableService,
	editFormState: item => `/sensor-type/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'name',
			text: 'Name',
			textKey: 'name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'manufacturer',
			text: 'Manufacturer',
			textKey: 'manufacturer',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'modelId',
			text: 'Model ID',
			textKey: 'modelId',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'maxSamplingRate',
			text: 'Max Sampling Rate',
			textKey: 'maxSamplingRate',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'externalId',
			text: 'External ID',
			textKey: 'externalId',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function SensorTypeTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('sensorTypeTable', reducer('sensorTypeTable'))(SensorTypeTable);
